module.exports = __webpack_public_path__ + "assets/signed.ad022c4a3c48603de4aeafbcb33267163d7fec67eb53749d86d8e68844855d17.png";